import { render, staticRenderFns } from "./VisionList.vue?vue&type=template&id=fc29ee4e&scoped=true&"
import script from "./VisionList.vue?vue&type=script&lang=js&"
export * from "./VisionList.vue?vue&type=script&lang=js&"
import style0 from "./VisionList.vue?vue&type=style&index=0&id=fc29ee4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc29ee4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc29ee4e')) {
      api.createRecord('fc29ee4e', component.options)
    } else {
      api.reload('fc29ee4e', component.options)
    }
    module.hot.accept("./VisionList.vue?vue&type=template&id=fc29ee4e&scoped=true&", function () {
      api.rerender('fc29ee4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Vision/VisionList.vue"
export default component.exports